import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function postSessionRecordingMetadata({
  appointmentId,
  s3Key,
  uploadMetadata,
  sessionType,
  sessionSource,
  orchidProJoined,
  orchidProLeft,
}: {
  appointmentId: string | number;

  // Leaving any of these values as null will leave as is any
  // corresponding saved value in the database
  s3Key?: string;
  uploadMetadata?: RecordingUploadMetadata; // { uploadId: string, uploadedPartsEtags: string[], recordedTime: number }
  sessionType?: AudioSessionType; // 'dictation', 'individual-patient', or 'couple'
  sessionSource?: Omit<SessionSource, "video-call">; // 'upload' or 'live-audio-recording'
  orchidProJoined?: boolean;
  orchidProLeft?: boolean;
}) {
  const payload = {
    appointment_id: appointmentId,
  };

  if (s3Key) {
    payload["s3_key"] = s3Key;
  }

  if (uploadMetadata) {
    payload["session_recording_upload_metadata"] = uploadMetadata;
  }

  if (sessionType) {
    payload["session_type"] = sessionType;
  }

  if (sessionSource) {
    payload["session_source"] = sessionSource;
  }

  if (orchidProJoined !== undefined) {
    payload["orchid_pro_joined"] = orchidProJoined;
  }

  if (orchidProLeft !== undefined) {
    payload["orchid_pro_left"] = orchidProLeft;
  }

  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/transcription/recording-metadata`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
  return res;
}
